import { tryGetHostApi } from "../app/externalApi/externalApi";
import { getIsWidgetsRestrictedDataSharingEnabled } from "../app/externalApi/DMAPolicyEvaluatorApi";
import { isFeatureEnabledInternal } from "../app/externalApi/VelocityApi";
import { TelemetryData } from "./TelemetryData";
class TraceLoggingDispatcher {
    async getIsDiagnosticDataEnabled() {
        if (this.isTraceLoggingEnabled === undefined) {
            const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
            if (telemetryApi) {
                telemetryApi.addEventListener("collectionlevelchanged", this.collectionLevelChangedCallback.bind(this));
                this.isTraceLoggingEnabled = (await telemetryApi.getIsDiagnosticDataLoggingEnabled());
                return this.isTraceLoggingEnabled;
            }
            // Assume diagnostic logging is disabled if we can't access the API
            return false;
        }
        else {
            return this.isTraceLoggingEnabled;
        }
    }
    async getIsDiagnosticDataSharingEnabled() {
        if (this.isDiagnosticDataSharingEnabled === undefined) {
            const isFeatureEnabled = await isFeatureEnabledInternal("Feature_DMARestrictDiagnosticData");
            if (isFeatureEnabled) {
                this.isDiagnosticDataSharingEnabled = !(await getIsWidgetsRestrictedDataSharingEnabled());
            }
            else {
                return true;
            }
        }
        return this.isDiagnosticDataSharingEnabled;
    }
    async dispatch(eventName, providerName, dmaDataCategory, privacyTag, keyword, tags, loggingLevel, partC) {
        let isDiagnosticDataEnabled = await this.getIsDiagnosticDataEnabled();
        let isDiagnosticDataSharingEnabled = await this.getIsDiagnosticDataSharingEnabled();
        // Only share data if:
        // 1. Diagnostic logging is enabled
        // 2. It is Required Service Data OR it is diagnostic data and sharing is enabled based on policy and VK
        if (window && isDiagnosticDataEnabled
            && (isDiagnosticDataSharingEnabled || dmaDataCategory === 0 /* requiredServiceData */)) {
            window.dispatchEvent(new CustomEvent("DashboardTelemetryEvent", {
                detail: {
                    eventName: eventName,
                    keyword: keyword,
                    loggingLevel: loggingLevel,
                    partC: Object.assign({ "view": TelemetryData.view }, partC),
                    privacyTag: privacyTag,
                    providerName: providerName,
                    tags: tags,
                },
            }));
        }
    }
    collectionLevelChangedCallback(isEnabled) {
        this.isTraceLoggingEnabled = isEnabled;
    }
}
export let traceLoggingDispatcher = new TraceLoggingDispatcher();
// for testing:
export function setTraceLoggingDispatcher(dispatcher) {
    traceLoggingDispatcher = dispatcher;
}
